import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "overlay", "list"]
  static values = { warnings: Object }

  connect() {
    this.confirmed = false
  }

  confirm(event) {
    if (this.confirmed) return

    const selectedBlockIds = Array.from(this.element.querySelectorAll("select[data-category-id]"))
      .map((select) => select.value)
      .filter((value) => value !== "")

    const warningEntries = selectedBlockIds
      .map((id) => this.warningsValue[id])
      .filter(Boolean)

    if (warningEntries.length === 0) return

    event.preventDefault()
    this.renderWarnings(warningEntries)
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  proceed() {
    this.confirmed = true
    this.close()
    this.element.requestSubmit()
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  renderWarnings(entries) {
    this.listTarget.innerHTML = ""

    entries.forEach((entry) => {
      const item = document.createElement("li")
      item.className = "rounded-lg bg-white/80 px-3 py-2"
      item.textContent = `${entry.label} · ${entry.date_label}`
      this.listTarget.appendChild(item)
    })
  }
}
